<template>
  <v-divider v-bind="{ ...$attrs, ...$props }" v-on="$listeners">
    <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
  </v-divider>
</template>

<script>
import { VDivider } from 'vuetify/lib';

export default {
  name: 'core-divider',
  isCustomElement: true,
  components: {
    VDivider,
  },
};
</script>
